import React from "react";
import Image01 from "../assets/svg/mygroup.svg";
import Image02 from "../assets/profile.svg";
import { MdOutlineGroups } from "react-icons/md";
import { formatNumber } from "../utils/dtos";
import { useGroup } from "../context/GroupContext";
import { usePost } from "../context/PostContext";

const MyGroup = ({ button, data }) => {

  const { joingroup, setOpenedGroup } = useGroup();
  const { setGroupData } =  usePost();

  const handleBtnClick = (data) => {
    if (button === 'View') {
      setOpenedGroup(data);
      setGroupData(data);
    }else{
      joingroup({ groupName: data?.groupName, description: data?.description, members: data?.members.map((gr) => gr?.userId) }, data?.id)
    }
  }

  return (
    <div className="shadow-xxl rounded-lg mb-2">
      <img src={data?.image || Image01} alt="" className="w-full h-36 object-cover rounded-t-lg" />
      <div className="p-3">
        <div className="flex justify-between">
          <div>
            <p className="text-sm font-medium">{data?.groupName}</p>
            <p className="text-[10px] truncate">{data?.description}</p>
          </div>
          <div className="flex items-center">
            <MdOutlineGroups className="text-xs text-primary" />
            <p className="text-[10px] ml-1">{formatNumber(data?.members.length)} Members</p>
          </div>
        </div>

        <div className="flex justify-between pt-3">
          <div className="flex items-center justify-center">
            {data?.members.map((member) => {
                if (member?.userId !== data.owner){
                  return (data?.members.indexOf(member) <= 6) && (<img alt="" title={member?.firstName + " " + member?.lastName} key={data?.members.indexOf(member)} className={`w-8 h-8 cursor-pointer rounded-full border-gray-200 border transform hover:scale-125 ${data?.members.indexOf(member) !== 0 && '-ml-1'}`} src={member.profilePicture || Image02} />)
                }
                return null
              })}
          </div>
          <button onClick={() => handleBtnClick(data)} className={`py-1 w-[45%] border-2 border-primary text-xs font-semibold rounded hover:border-none ${button === 'View' ? 'hover:bg-primary bg-white text-primary hover:text-white' : 'hover:bg-white bg-primary text-white hover:text-primary'}`}>
            {button}
          </button>
        </div>
      </div>
    </div>
  );
};

export default MyGroup;
